export default __webpack_public_path__ + "static/media/ucla-getting-started.41c65ede.jpg";